import { Container, styled } from "@mui/material";

const TAB_APPROACH_PREFIX = "TabApproach";

export const tabApproachClasses = {
  root: `${TAB_APPROACH_PREFIX}-root`,
};

export const StyledTabApproach = styled(Container)(({ theme }) => ({}));
